module.exports = __webpack_public_path__ + "static/img/14000546.ff18d136.png";